export const PasswordValidationRules = {
  minLength: 8,
  maxLength: 32,
  hasUpperCase: /[A-Z]/,
  hasLowerCase: /[a-z]/,
  hasNumber: /[0-9]/,
  hasSpecialChar: /[^a-zA-Z0-9\s]/, // Anything that's not alphanumeric or whitespace
}

export function validatePassword(password: string) {
  return {
    length:
      password.length >= PasswordValidationRules.minLength && password.length <= PasswordValidationRules.maxLength,
    hasUpperCase: PasswordValidationRules.hasUpperCase.test(password),
    hasLowerCase: PasswordValidationRules.hasLowerCase.test(password),
    hasNumber: PasswordValidationRules.hasNumber.test(password),
    hasSpecialChar: PasswordValidationRules.hasSpecialChar.test(password),
  }
}

export function isPasswordValid(password: string): boolean {
  const validation = validatePassword(password)
  return Object.values(validation).every(Boolean)
}
